import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo.png';

// Logo, portal badge, title and subtitle shown above the password-reset forms.
const AuthPageHeader = ({ title, subtitle, logoAlt = 'Doves' }) => (
  <div className="text-center mb-8 flex flex-col items-center">
    <Link to="/landing" className="flex items-center justify-center space-x-3 mb-6">
      <img className="h-10 w-auto" src={logo} alt={logoAlt} />
      <span className="bg-[#EBF5FF] text-[#135A9C] font-black text-[10px] px-3 py-1 rounded-full uppercase tracking-widest">
        Self-Service Portal
      </span>
    </Link>
    <h1 className="text-2xl font-extrabold text-slate-800 mt-2 tracking-tight">{title}</h1>
    <p className="mt-2 text-sm text-slate-500">{subtitle}</p>
  </div>
);

export default AuthPageHeader;
